export const baseUrl = "https://alma3ard.thedevora.tech/api";

export const loginURL = "v1/login";

export const workshopsURL = "v1/workshops";

export const tagsURL="v1/tags"

export const governoratesURL = "v1/governorates";

export const carBrandsURL = "v1/car_brands";

export const gearTypesURL = "v1/gear_types";

export const fuelTypesURL="v1/fuel_types"

export const favoriteListingsURL ="v1/favorite_listings"

export const colorsURL="v1/colors"

export const carTypesURL="v1/car_types"

export const carModelsURL="v1/car_models"

export const importingCountriesURL="v1/importing_countries"

export const mediaURL="v1/media"

export const listingsURL="v1/listings"

export const areasURL = "v1/areas";

export const advertisementsURL="v1/advertisements"

export const productsURL ="/v1/products"

export const usersURL = "v1/users";

export const ordersURL = "v1/orders";

export const discountTimestampRangeURL="/dashboard/discount-timestamp-range"

export const categoriesURL ="/dashboard/categories"

export const subCatURL="/dashboard/categories/get-subs"

export const privacyPolicyURL="/dashboard/privacy-policy"

export const discountCouponsURL="/dashboard/discount-coupons"

export const clientsURL = "clients/";

export const trainersURL = "trainers";

export const clientURL = "dashboard/clients";

export const employeesURL = "dashboard/employees";


export const permissionsURL = "permissions";

export const notificationsURL = "v1/notifications";


export const notificationsInfoURL="dashboard/info-notifications"

export const statisticsURL = "/dashboard/statistics";

export const departmentsURL = "departments";

export const contactUsURL = "contact-us";





export const storeInfoURL="/dashboard/store-info"





export const shippingSettingsURL ="dashboard/shipping-setting"


